module.exports = __webpack_public_path__ + "img/bs_silo_5.ea3ca420.png";